(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!customElements.get('am-cart-recommendations')) {
  customElements.define('am-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.drawer = this.closest('cart-drawer');
      this.list = this.querySelector('[data-am-recommendations]');
      this.error = this.querySelector('[role="alert"]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency', currency:this.dataset.currency || 'AUD', currencyDisplay:'narrowSymbol'});
      this.addEventListener('click', event => {
        const arrow = event.target.closest('[data-direction]');
        if (arrow) this.list.scrollBy({left:Number(arrow.dataset.direction)*(this.list.clientWidth+12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }, {signal:this.controller.signal});
      this.addEventListener('change', event => {
        if (event.target.matches('select[name="id"]')) {
          const variant = event.target.selectedOptions[0];
          const card = event.target.closest('.am-cart__card');
          card.querySelector('[data-am-price]').textContent = this.money.format(Number(variant.dataset.price)/100);
          if (variant.dataset.image) card.querySelector('img').src = variant.dataset.image;
        }
      }, {signal:this.controller.signal});
      this.addEventListener('cart:error', event => {
        this.error.textContent = event.detail.error || this.dataset.error;
        this.error.hidden = false;
      }, {signal:this.controller.signal});
      this.drawer.addEventListener('dialog:before-show', () => this.load(), {signal:this.controller.signal});
      this.load();
      this.syncArrows();
    }
    disconnectedCallback() {this.controller.abort();}
    syncArrows() {
      const count = this.list.children.length;
      this.querySelectorAll('[data-direction]').forEach(button => button.disabled = count < 2);
      this.hidden = count === 0;
    }
    async load() {
      if (this.loaded) return;
      this.loaded = true;
      const ids = JSON.parse(this.dataset.productIds || '[]');
      const root = window.Shopify.routes.root;
      try {
        const results = await Promise.all(ids.slice(0,2).map(async id => {
          const response = await fetch(`${root}recommendations/products.json?product_id=${encodeURIComponent(id)}&limit=10&intent=related`, {signal:this.controller.signal});
          if (!response.ok) return [];
          return (await response.json()).products || [];
        }));
        const seen = new Set(ids.map(String));
        const products = results.flat().filter(product => {
          if (!product.available || product.price <= 0 || seen.has(String(product.id))) return false;
          seen.add(String(product.id)); return true;
        }).slice(0,5);
        if (!this.isConnected || !products.length) return;
        const fragment = document.createDocumentFragment();
        products.forEach(product => {
          const variants = product.variants.filter(variant => variant.available);
          if (!variants.length) return;
          const card = document.createElement('article'); card.className='am-cart__card';
          const imageLink = document.createElement('a'); imageLink.href=product.url;
          const image=document.createElement('img'); image.alt=product.title; image.loading='lazy'; image.width=80; image.height=112;
          image.src=product.featured_image || product.images[0]; imageLink.append(image);
          const info=document.createElement('div'); info.className='am-cart__card-info';
          const title=document.createElement('a'); title.className='am-cart__card-title'; title.href=product.url; title.textContent=product.title; title.title=product.title;
          const price=document.createElement('p'); price.dataset.amPrice=''; price.textContent=this.money.format(variants[0].price/100);
          const productForm=document.createElement('product-form');
          const form=document.createElement('form'); form.method='post'; form.action=`${root}cart/add`; form.id=`am-rec-${product.id}`;
          const select=document.createElement('select'); select.name='id'; select.setAttribute('aria-label',this.dataset.variant);
          variants.forEach(variant => {
            const option=document.createElement('option'); option.value=variant.id; option.textContent=variant.title; option.dataset.price=variant.price;
            if (variant.featured_image?.src) option.dataset.image=variant.featured_image.src;
            select.append(option);
          });
          const quantity=document.createElement('input'); quantity.type='hidden'; quantity.name='quantity'; quantity.value='1';
          const success=document.createElement('input'); success.type='hidden'; success.name='on_success'; success.value='force_open_drawer';
          const button=document.createElement('button'); button.type='submit'; button.className='am-cart__add'; button.textContent=this.dataset.add;
          form.append(quantity,success,select,button); productForm.append(form); info.append(title,price,productForm); card.append(imageLink,info); fragment.append(card);
        });
        this.list.replaceChildren(fragment); this.syncArrows();
      } catch (error) {
        if (error.name !== 'AbortError') this.syncArrows();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.dore-featured-header .featured-collections-navigation button');
    if (!button) return;
    const header = button.closest('.dore-featured-header');
    const index = Array.from(button.parentElement.children).indexOf(button);
    header.querySelectorAll('[data-dore-collection-link]').forEach(link => {
      link.hidden = Number(link.dataset.doreCollectionLink) !== index;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
